import React /*, { useMemo, useState, useEffect, useCallback } */ from "react";
// import { useHistory } from "react-router";
// import { parse, stringify } from "query-string";
// import FirebasePaginator from "firebase-paginator";

import withFirebasePagination from "../lib/firebase-paginated";
import { firebase } from "../contexts/filrebase";
import RoomsList from "../components/RoomsList";
import Navbar from "../components/Navbar";
import Page from "../components/Page";
import Header from "../components/Header";
import reloadPage from "../lib/reloadAndUpdate";
import navigationMessages from "../i18n/navigation";
// firebase pagination
// import getRef from "../lib/firebase-paginated/utils/getFirebaseRef";
// import getSnapshotItems from "../lib/firebase-paginated/utils/getSnapshotItems";

/**
 * @name usePublicRooms
 * @param {{cursor?: string}} props
 * @returns {{
 *    data: Array<{
 *      id: string;
 *      value: object;
 *      proprity: any;
 *    }> | null,
 *    loading: boolean,
 *    errors: Array<any>|null
 *    hasNext: boolean,
 *    hasPrev: boolean,
 *    nextCursor: string|null,
 *    prevCursor: string|null,
 * }}
 */
// const usePublicRooms = ({
//   front = true,
//   cursor = null,
//   path = "/rooms",
//   orderBy = "createdAt",
//   length = 1,
//   pageNumber = 1,
// } = {}) => {
//   let [state, setState] = useState({
//     data: null,
//     loading: false,
//     errors: null,
//     hasNext: false,
//     hasPrev: false,
//     nextCursor: null,
//     prevCursor: null,
//     pageCount: 1,
//     pageNumber,
//   });
//   const dbRef = useMemo(() => {
//     return getRef(firebase);
//   }, []);
//   const allItemsRef = useMemo(() => {
//     const ref = dbRef.child(path).orderByKey();
//     return ref;
//   }, [dbRef]);

//   useEffect(() => {
//     console.log("query rooms", { allItemsRef, cursor, front, length });
//     setState((currentState) => ({ ...currentState, loading: true }));

//     const itemsRef = front
//       ? cursor
//         ? // next after cursor
//           allItemsRef.endAt(cursor).limitToLast(length + 1)
//         : allItemsRef.limitToFirst(length + 1)
//       : allItemsRef.startAt(cursor).limitToFirst(length + 2);
//     // const itemsRef = front
//     //   ? cursor
//     //     ? allItemsRef.endAt(cursor).limitToLast(length + 1)
//     //     : allItemsRef.limitToLast(length + 1)
//     //   : allItemsRef.startAt(cursor).limitToFirst(length + 2);

//     const unsubscribeFromItems = itemsRef.on("value", (snapshot) => {
//       console.log({ snapshot });
//       const items = snapshot ? getSnapshotItems(snapshot) : [];
//       console.log({ items });
//       // setState((currentState) => ({
//       //   ...currentState,
//       //   hasNext,
//       //   hasPrev,
//       //   data: front ? items.slice(0, length) : items.slice(-length),
//       //   loading: false,
//       //   nextCursor: nextItem ? nextItem.id : null,
//       //   prevCursor: prevItem ? prevItem.id : null,
//       // }));
//     });

//     return () => {
//       unsubscribeFromItems();
//     };
//   }, [allItemsRef, cursor, length, front]);
//   const fetchMore = useCallback(({ nextCursor, prevCursor } = {}) => {}, [
//     state.data,
//     state.hasNext,
//     state.hasPrev,
//     cursor,
//     front,
//   ]);

//   var paginator = useMemo(
//     () =>
//       new FirebasePaginator(dbRef.child("/rooms"), {
//         finite: true,
//         pageSize: length,
//       }),
//     [dbRef, length]
//   );
//   useEffect(() => {
//     window.paginator = paginator;
//     paginator.on("value", (shapshot) => {
//       const items = getSnapshotItems(shapshot);
//       console.log("[paginator] shapshot", shapshot, items);
//       setState((cur) => ({
//         ...cur,
//         data: items,
//         loading: false,
//         pageNumber: paginator.pageNumber,
//         pageCount: paginator.pageCount,
//         isLastPage: paginator.isLastPage,
//         hasPrev: !paginator.isLastPage,
//         hasNext: true,
//       }));
//     });
//     paginator.listen(function (eventName, eventPayload) {
//       console.log(
//         `[paginator] Fired ${eventName} with the following payload: `,
//         eventPayload
//       );
//     });
//     return () => {
//       paginator.off();
//     };
//   }, [paginator]);

//   useEffect(() => {
//     console.log("[paginator] NEW pageNumber", pageNumber, paginator);
//     if (pageNumber !== paginator.pageNumber) {
//       setTimeout(() => paginator.goToPage(pageNumber), 0);
//     }
//   }, [pageNumber]);

//   console.log("returns", {
//     fetchMore,
//     ...state,
//   });
//   return {
//     fetchMore,
//     ...state,
//   };
// };

export const RoomsView = withFirebasePagination(firebase)({
  path: "/rooms",
  orderBy: "createdAt",
  length: 10,
})(RoomsList);

export default () => {
  // const history = useHistory();
  // const location = history.location;
  // const { cursor, next, prev, pageNumber, ...params } = useMemo(() => {
  //   const rawParams = parse(location.search);
  //   return {
  //     cursor: rawParams.cursor,
  //     pageNumber: rawParams.page,
  //     next: +rawParams.next || 10,
  //     prev: +rawParams.prev || 0,
  //   };
  // }, [location.search]);

  // ROOMS
  // const {
  //   data: rooms,
  //   loading,
  //   hasNext,
  //   hasPrev,
  //   nextCursor,
  //   prevCursor,
  //   pageNumber: realPageNumber,
  //   pageCount,
  // } = usePublicRooms(
  //   cursor
  //     ? {
  //         cursor: cursor || null,
  //         front: !prev,
  //         length: prev || next || 10,
  //         pageNumber,
  //       }
  //     : {
  //         cursor: null,
  //         front: true,
  //         length: prev || next || 10,
  //         pageNumber,
  //       }
  // );
  // useEffect(() => {
  //   if (pageCount && pageNumber > pageCount) {
  //     console.log("oops, pageNumber > pageCount", realPageNumber, pageNumber);
  //   }
  // }, [realPageNumber, pageNumber, pageCount]);

  // const onNextPage = useCallback(() => {
  //   console.log("onNextPage");
  //   const newParams = {
  //     // ...params,
  //     // cursor: nextCursor,
  //     // next: next || 10,
  //     page: hasPrev ? realPageNumber + 1 : realPageNumber,
  //   };
  //   const newSearch = stringify(newParams);
  //   console.log({ newSearch });
  //   history.push({
  //     ...location,
  //     search: `?${newSearch}`,
  //   });
  // }, [hasPrev, realPageNumber, params, nextCursor, history, location]);

  // const onPrevPage = useCallback(() => {
  //   console.log("onNextPage");
  //   const newParams = {
  //     ...params,
  //     cursor: prevCursor,
  //     prev: prev || 10,
  //   };
  //   const newSearch = stringify(newParams);
  //   console.log({ newSearch });
  //   history.push({
  //     ...location,
  //     search: `?${newSearch}`,
  //   });
  // }, [hasNext, cursor, next, prev, params, prevCursor, history, location]);
  return (
    <Page>
      <Navbar
        items={[
          { to: "/rooms/new", text: navigationMessages.createNewRoom },
          { to: "/", text: navigationMessages.reload, onClick: reloadPage },
          { to: "/logout", text: navigationMessages.logout },
        ]}
      />
      <Header size="h1" paddingX={10}>
        Rooms{" "}
        <span role="img" aria-label="rooms icon">
          📚
        </span>
      </Header>
      {/* <RoomsList
        pageItems={rooms || []}
        isLoading={loading}
        hasPrevPage={hasPrev}
        hasNextPage={hasNext}
        onNextPage={onNextPage}
        onPrevPage={onPrevPage}
      /> */}
      <RoomsView />
    </Page>
  );
};
